import { render, staticRenderFns } from "./ReportsCenter.vue?vue&type=template&id=c7e2b812&scoped=true"
import script from "./ReportsCenter.vue?vue&type=script&lang=js"
export * from "./ReportsCenter.vue?vue&type=script&lang=js"
import style0 from "./ReportsCenter.vue?vue&type=style&index=0&id=c7e2b812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e2b812",
  null
  
)

export default component.exports